import type { LucideIcon } from 'lucide-react';

interface TituloPaginaProps {
  icono: LucideIcon;
  titulo: string;
  descripcion?: string;
}

/**
 * Título de las pantallas del portal.
 *
 * Lleva el icono de la sección en un cuadro con el degradado de marca: es el
 * punto de color de cada pantalla (antes era un `<h1>` en tinta oscura sobre
 * blanco, y el portal entero se veía apagado). Las acciones de la pantalla
 * (agregar, exportar, actualizar…) se quedan en el `flex` que envuelve a este
 * componente, para que cada página decida qué botones muestra.
 */
export function TituloPagina({ icono: Icono, titulo, descripcion }: TituloPaginaProps) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <span className="flex size-11 shrink-0 items-center justify-center rounded-card bg-gradient-to-br from-brand-500 to-accent-500 text-white shadow-brand">
        <Icono className="size-5" aria-hidden="true" />
      </span>

      <div className="min-w-0">
        <h1 className="text-xl font-bold tracking-tight text-ink-900">{titulo}</h1>
        {descripcion ? <p className="mt-0.5 text-sm text-ink-500">{descripcion}</p> : null}
      </div>
    </div>
  );
}
